'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024$0024anon$002421 from "./presto.types$-Envelope-Title$$anon$21.js";
import * as $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024$0024anon$002422 from "./presto.types$-Envelope-Title$$anon$22.js";
var $p;
/** @constructor */
function $c_Lpresto_types$EnvelopeTitle$() {
  this.c6D = null;
  this.c6E = false;
  this.c6B = null;
  this.c6C = false;
  this.c6F = null;
  this.c6G = false;
  this.c6H = null;
  this.c6I = false;
}
export { $c_Lpresto_types$EnvelopeTitle$ as $c_Lpresto_types$EnvelopeTitle$ };
$p = $c_Lpresto_types$EnvelopeTitle$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$EnvelopeTitle$;
/** @constructor */
function $h_Lpresto_types$EnvelopeTitle$() {
}
export { $h_Lpresto_types$EnvelopeTitle$ as $h_Lpresto_types$EnvelopeTitle$ };
$h_Lpresto_types$EnvelopeTitle$.prototype = $p;
$p.cI2 = (function() {
  if ((!this.c6E)) {
    this.c6D = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c6E = true;
  }
  return this.c6D;
});
$p.nJ = (function() {
  if ((!this.c6C)) {
    this.c6B = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c6C = true;
  }
  return this.c6B;
});
$p.cIu = (function() {
  if ((!this.c6G)) {
    this.c6F = new $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024$0024anon$002421.$c_Lpresto_types$EnvelopeTitle$$anon$21(this);
    this.c6G = true;
  }
  return this.c6F;
});
$p.cIZ = (function() {
  if ((!this.c6I)) {
    this.c6H = new $j_presto$002etypes$0024$002dEnvelope$002dTitle$0024$0024anon$002422.$c_Lpresto_types$EnvelopeTitle$$anon$22(this);
    this.c6I = true;
  }
  return this.c6H;
});
var $d_Lpresto_types$EnvelopeTitle$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$EnvelopeTitle$, "presto.types$EnvelopeTitle$", ({
  a00: 1,
  D: 1
}));
export { $d_Lpresto_types$EnvelopeTitle$ as $d_Lpresto_types$EnvelopeTitle$ };
var $n_Lpresto_types$EnvelopeTitle$;
function $m_Lpresto_types$EnvelopeTitle$() {
  if ((!$n_Lpresto_types$EnvelopeTitle$)) {
    $n_Lpresto_types$EnvelopeTitle$ = new $c_Lpresto_types$EnvelopeTitle$();
  }
  return $n_Lpresto_types$EnvelopeTitle$;
}
export { $m_Lpresto_types$EnvelopeTitle$ as $m_Lpresto_types$EnvelopeTitle$ };
//# sourceMappingURL=presto.types$-Envelope-Title$.js.map
